export default "__VITE_ASSET__BCuH7W9v__"